// 数据导入
import {
  inputData,
  getStatus,
  depotValume,
  orderPlant
} from '@/api/oli_api'

import {
  readExcelFileData
} from '@/cllib'

const state = {
  // 需要导入当日进销存数据，今天的运送计划，油库指标量
  // 每导入成功一个加1 到3的时候导入完成
  inputJxcOk: false,
  inputOrderPlantOk: false,
  inputDepotValumeOk: false,
  inputToGoodsOk: false,
  toGoodsErrorData: [],
  toGoodsCount: []
}

const getters = {
  toGoodsCount: state => state.toGoodsCount,
  toGoodsErrorData: state => state.toGoodsErrorData,
  inputJxcOk: state => state.inputJxcOk,
  inputOrderPlantOk: state => state.inputOrderPlantOk,
  inputDepotValumeOk: state => state.inputDepotValumeOk,
  inputToGoodsOk: state => state.inputToGoodsOk
}

let dealJxcMap = function (dataMap) {
  let dataOne = {}
  for (let key in dataMap) {
    if (key.indexOf('L') !== -1) {
      dataOne[key.slice(0, -3)] = Number(dataMap[key]) || 0
    } else if (key === 'Retail组') {
      dataOne['RETAIL组'] = dataMap[key]
    } else if (key === 'Retail罐号') {
      dataOne['RETAIL罐号'] = dataMap[key]
    } else if (key === 'Retail状态') {
      dataOne['RETAIL状态'] = dataMap[key]
    } else if (key === '进货差值') {
      dataOne[key] = Number(dataMap[key]) || 0
    } else {
      dataOne[key] = dataMap[key]
    }
  }
  return dataOne
}

const actions = {
  dealJxcExceldata ({ commit, getters, dispatch }, {excelFile, fileId, date}) {
    let sheets = [{
      needDataKeys: ['区域', '单位名称', '加油站名称', '油品名称', '油站代码', '罐号', '油罐状态', '期初库存(L)', '入库升数(L)', '出库升数(L)', '期末库存(L)', '空容(L)', '损溢(L)', '平均销量(L)', '在途计划升数(L)', '配送计划(L)', '物理容积(L)', '停泵库存(L)', '有效容积(L)', '库存时间', '班次', 'Retail罐号', 'Retail状态', '进货差值', '传输状态', '数据来源', '采集时间', '传输时间', 'Retail组']
    }]
    readExcelFileData({file: excelFile, sheets, allsheets: true, type: 'row_object_array'}).then(function (data) {
      let allData = []
      for (let key in data) {
        data[key].forEach(function (item) {
          item['日期'] = date || getters.yesterDayStr
          let newMap = dealJxcMap(item)
          allData.push(newMap)
        })
      }
      dispatch('inputJxcData', allData)
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入文件解析失败',
        message: '请检查文件格式是否符合导入规则'
      })
      document.getElementById(fileId).value = ''
    })
  },
  inputJxcData ({ commit, dispatch }, allData) {
    dispatch('showNoticeMsg', {
      type: 'success',
      title: '系统提示',
      message: '传输数据到服务器！'
    })
    dispatch('setLoading', true)
    dispatch('setLoadingText', '导入数据中')
    dispatch('setPercentage', {'start': 0, 'next': 100})
    inputData(allData).then(function (data) {
      dispatch('getInsertJxcDataStatus')
    }).catch((e) => {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '系统提示',
        message: '数据传输至服务器失败,请联系管理员'
      })
    })
  },
  getInsertJxcDataStatus ({ dispatch }, data) {
    setTimeout(function () {
      getStatus({key: 'inputData'}).then(function (data) {
        let inputStatus = data.data
        if (inputStatus === 'doing') {
          dispatch('getInsertJxcDataStatus')
        } else {
          dispatch('loadInputData')
          dispatch('setLoadingText', '数据导入完成')
          dispatch('setPercentage', {'start': 100, 'next': 100})
        }
      })
    }, 5000)
  },
  inputDepotValume ({ commit, dispatch, getters }, {excelFile, fileId}) {
    readExcelFileData({file: excelFile, allsheets: true, type: 'csv'}).then(function (data) {
      let needData = ''
      for (let key in data) {
        if (!needData) {
          needData = key
        }
      }
      let newData = [{
        '油库代码': '33450015',
        '油品': '92号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][12][5])
      },
      {
        '油库代码': '33450015',
        '油品': '95号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][13][5])
      },
      {
        '油库代码': '33450015',
        '油品': '98号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][14][5])
      },
      {
        '油库代码': '33450015',
        '油品': '0号车用柴油(Ⅴ)',
        '指标量': Number(data[needData][17][5])
      },
      {
        '油库代码': '33450016',
        '油品': '92号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][18][5])
      },
      {
        '油库代码': '33450016',
        '油品': '95号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][19][5])
      },
      {
        '油库代码': '33450016',
        '油品': '98号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][20][5])
      },
      {
        '油库代码': '33450016',
        '油品': '0号车用柴油(Ⅴ)',
        '指标量': Number(data[needData][23][5])
      },
      {
        '油库代码': '36910016',
        '油品': '92号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][94][5])
      },
      {
        '油库代码': '36910016',
        '油品': '95号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][95][5])
      },
      {
        '油库代码': '36910016',
        '油品': '98号车用汽油(Ⅴ)',
        '指标量': Number(data[needData][96][5])
      },
      {
        '油库代码': '36910016',
        '油品': '0号车用柴油(Ⅴ)',
        '指标量': Number(data[needData][99][5])
      }]
      let inputDatas = []
      newData.forEach((item) => {
        inputDatas.push({'油库代码': item['油库代码'], '油品名称': item['油品'], '指标量': item['指标量'], '区域': '昆明', '日期': getters.todayStr})
      })
      depotValume({action: 'add_depot_valume', data: inputDatas}).then((data) => {
        if (data['code'] !== '-1') {
          dispatch('setInputDepotValumeOk')
        } else {
          throw new Error('error')
        }
      }).catch((e) => {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '数据传输至服务器失败,请联系管理员'
        })
      })
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入文件解析失败',
        message: '请检查文件格式是否符合导入规则'
      })
      document.getElementById(fileId).value = ''
      console.log(e)
    })
  },
  inputOlderPlan ({ commit, dispatch, getters }, {excelFile, fileId, date, realData}) {
    let sheets = [{
      needDataKeys: ['车辆', '灌号', '油品名称', '配送升数', 'ERP出库时间', '发站代码', '到站代码', '配送升数ERP', 'ERP单号', '趟', '隔舱']
    }]
    date = date || getters.todayStr
    readExcelFileData({file: excelFile, sheets, allsheets: true, type: 'row_object_array'}).then(function (data) {
      let allData = []
      for (let key in data) {
        data[key].forEach(function (item) {
          item['时间'] = date
          allData.push(item)
        })
      }
      orderPlant({action: realData === 2 ? 'input_data_pssj' : (realData ? 'input_data_real' : 'input_data'), data: {data: allData, date}}).then((data) => {
        if (data['code'] !== '-1') {
          dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '导入配送计划成功'
          })
          dispatch('setInputOrderPlantOk')
        } else {
          throw new Error('error')
        }
      })
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入文件解析失败',
        message: '请检查文件格式是否符合导入规则'
      })
      document.getElementById(fileId).value = ''
      console.log(e)
    })
  },
  inputToGoods ({ commit, dispatch, getters }, {excelFile, fileId}) {
    dispatch('setToGoodsErrorData', [])
    dispatch('setToGoodsCount', [])
    let sheets = [{
      needDataKeys: ['加油站代码', '92#', '95#', '98#', '0#', '备注']
    }]
    readExcelFileData({file: excelFile, sheets, allsheets: true, type: 'row_object_array'}).then(function (data) {
      let allData = []
      for (let key in data) {
        data[key].forEach(function (item) {
          item['日期'] = getters.todayStr
          allData.push(item)
        })
      }
      orderPlant({action: 'input_to_goods_data', data: allData}).then((data) => {
        if (data['code'] !== '-1') {
          if (data['errorData'] && data['errorData'].length > 0) {
            dispatch('showNoticeMsg', {
              type: 'error',
              title: '系统提示',
              message: '导入要货数据异常'
            })
            dispatch('setToGoodsErrorData', data['errorData'])
            document.getElementById(fileId).value = ''
          } else {
            dispatch('setToGoodsCount', data['count'])
            dispatch('setInputToGoodsOk')
          }
        } else {
          throw new Error('error')
        }
      }).catch((e) => {
        dispatch('showNoticeMsg', {
          type: 'error',
          title: '导入文件失败',
          message: '请联系管理员'
        })
        document.getElementById(fileId).value = ''
      })
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入文件解析失败',
        message: '请检查文件格式是否符合导入规则'
      })
      document.getElementById(fileId).value = ''
      console.log(e)
    })
  },
  inputCarData ({ commit, dispatch, getters }, {excelFile, fileId}) {
    let sheets = [{
      needDataKeys: ['配送中心', '承运商', '车牌号', '挂车牌号', '车辆轴数', '核定载质量', '道路运输证准运油品', '电子运单装载油品', '合计', '前仓', '中仓', '后仓', '停车点']
    }]
    readExcelFileData({file: excelFile, sheets, allsheets: true, type: 'row_object_array'}).then(function (data) {
      let allData = []
      for (let key in data) {
        data[key].forEach(function (item) {
          allData.push(item)
        })
      }
      orderPlant({action: 'input_data', data: allData}).then((data) => {
        if (data['code'] !== '-1') {
          dispatch('setInputOrderPlantOk')
        } else {
          throw new Error('error')
        }
      })
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '导入文件解析失败',
        message: '请检查文件格式是否符合导入规则'
      })
      document.getElementById(fileId).value = ''
      console.log(e)
    })
  },
  checkInputStatus ({ dispatch, getters }) {
    if (getters.inputJxcOk && getters.inputOrderPlantOk && getters.inputDepotValumeOk) {
      dispatch('setFlowStatus', 10)
    }
  },
  setInputJxcOk ({ commit, dispatch }) {
    commit('setInputJxcOk', true)
    dispatch('checkInputStatus')
  },
  setInputToGoodsOk ({ commit, dispatch }) {
    commit('setInputToGoodsOk', true)
  },
  setInputOrderPlantOk ({ commit, dispatch }) {
    commit('setInputOrderPlantOk', true)
    dispatch('checkInputStatus')
  },
  setInputDepotValumeOk ({ commit, dispatch }) {
    commit('setInputDepotValumeOk', true)
    dispatch('checkInputStatus')
  },
  setToGoodsErrorData ({ commit }, data) {
    commit('setToGoodsErrorData', data)
  },
  setToGoodsCount ({ commit }, data) {
    commit('setToGoodsCount', data)
  }
}

const mutations = {
  setToGoodsCount (state, data) {
    state.toGoodsCount = data
  },
  setToGoodsErrorData (state, data) {
    state.toGoodsErrorData = data
  },
  setInputJxcOk (state, data) {
    state.inputJxcOk = data
  },
  setInputOrderPlantOk (state, data) {
    state.inputOrderPlantOk = data
  },
  setInputToGoodsOk (state, data) {
    state.inputToGoodsOk = data
  },
  setInputDepotValumeOk (state, data) {
    state.inputDepotValumeOk = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/oil/input_data.js